module.exports = __webpack_public_path__ + "img/04-SiteFC-01.d2e8abf9.png";